
      import { ConsoleLogger, checkLoafSupport } from "/main.js";

      const logger = new ConsoleLogger(document.getElementById("output"));
      const diagnosisDiv = document.getElementById("diagnosis");
      const slowButton = document.getElementById("slowButton");
      const clearBtn = document.getElementById("clearBtn");

      // Verificar soporte
      checkLoafSupport();

      // Cache de LoAFs recientes
      const recentLoafs = [];

      // Observer de LoAF (capturar frames lentos)
      const loafObserver = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          recentLoafs.push(entry);
          // Mantener solo los últimos 50
          if (recentLoafs.length > 50) {
            recentLoafs.shift();
          }
        }
      });

      try {
        loafObserver.observe({
          type: "long-animation-frame",
          buffered: true,
        });
      } catch (e) {
        logger.error("LoAF no soportado");
      }

      // Función para encontrar el LoAF relacionado con un evento
      function findRelatedLoaf(eventEntry) {
        // Buscar LoAF que se superponga con el evento
        return recentLoafs.find((loaf) => {
          const loafEnd = loaf.startTime + loaf.duration;
          const eventEnd = eventEntry.startTime + eventEntry.duration;

          // ¿Se superponen en el tiempo?
          return loaf.startTime <= eventEnd && loafEnd >= eventEntry.startTime;
        });
      }

      // Observer de Event Timing (capturar interacciones)
      const eventObserver = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          // Solo interacciones con interactionId (clicks, taps, etc.)
          if (!entry.interactionId) continue;

          // Solo procesar eventos 'click' para evitar duplicación
          if (entry.name !== "click") continue;

          // Solo interacciones lentas (>100ms para ver más casos)
          if (entry.duration <= 100) continue;

          logger.log("");
          logger.log("═══════════════════════════════════════════════════");
          logger.log("🔍 INTERACCIÓN LENTA DETECTADA");
          logger.log("═══════════════════════════════════════════════════");
          logger.log("");

          // Info del evento
          logger.log("📊 Event Timing API:");
          logger.log(`   • Tipo: ${entry.name}`);
          logger.log(`   • Duración: ${entry.duration}ms`);
          logger.log(`   • Target: ${entry.target?.tagName}#${entry.target?.id || "(sin id)"}`);
          logger.log(`   • Interaction ID: ${entry.interactionId}`);
          logger.log("");

          // Buscar el LoAF correspondiente (con delay para asegurar que LoAF se haya reportado)
          logger.log("🔎 Buscando LoAF relacionado...");

          // Esperar un poco para que se reporte el LoAF
          setTimeout(() => {
            const relevantLoaf = findRelatedLoaf(entry);

            if (relevantLoaf) {
              logger.log("✅ LoAF encontrado!");
              logger.log("");
              logger.log("📜 Long Animation Frame API:");
              logger.log(`   • Frame duration: ${relevantLoaf.duration}ms`);
              logger.log(`   • Blocking duration: ${relevantLoaf.blockingDuration}ms`);
              logger.log(`   • Scripts ejecutados: ${relevantLoaf.scripts.length}`);
              logger.log("");

              // Mostrar scripts
              logger.log("🎯 Scripts responsables:");
              relevantLoaf.scripts.forEach((script, i) => {
                logger.log("");
                logger.log(`   Script #${i + 1}:`);
                logger.log(`   ├─ Función: ${script.sourceFunctionName || "(anónima)"}`);
                logger.log(`   ├─ Invocado por: ${script.invoker || "N/A"}`);
                logger.log(`   ├─ Duración: ${script.duration}ms`);
                logger.log(`   └─ Forced layout: ${script.forcedStyleAndLayoutDuration}ms`);
              });
              logger.log("");

              // Identificar el culpable principal (script más largo)
              const culprit = relevantLoaf.scripts.reduce(
                (max, script) => (script.duration > max.duration ? script : max),
                { duration: 0 },
              );

              logger.warn("⚠️  CULPABLE PRINCIPAL:");
              logger.warn(`   Función: ${culprit.sourceFunctionName || "(anónima)"}`);
              logger.warn(`   Duración: ${culprit.duration}ms`);
              logger.log("");

              // Actualizar diagnóstico
              diagnosisDiv.innerHTML = `
              <div class="metric poor">
                INP: ${entry.duration}ms
                <small style="display: block; font-weight: normal; margin-top: 4px;">
                  Causado por: <strong>${culprit.sourceFunctionName || "función anónima"}</strong> (${culprit.duration}ms)
                </small>
              </div>
            `;
            } else {
              logger.warn("❌ No se encontró LoAF relacionado");
              logger.warn("   (Puede que el frame no fuera >50ms o aún no se haya reportado)");
              logger.log("");

              diagnosisDiv.innerHTML = `
              <div class="metric needs-improvement">
                INP: ${entry.duration}ms
                <small style="display: block; font-weight: normal; margin-top: 4px;">
                  No se detectó LoAF relacionado
                </small>
              </div>
            `;
            }

            logger.log("═══════════════════════════════════════════════════");
            logger.log("");
          }, 100); // Delay de 100ms para permitir que se reporte el LoAF
        }
      });

      try {
        eventObserver.observe({
          type: "event",
          buffered: true,
          durationThreshold: 100, // Lowered threshold to catch more events
        });
      } catch (e) {
        logger.error("Event Timing no soportado");
      }

      // Botón que genera interacción lenta
      slowButton.addEventListener("click", function handleSlowClick() {
        logger.log("👆 Click detectado, procesando...");
        diagnosisDiv.textContent = "Procesando...";

        // Simulación de procesamiento pesado
        heavyComputation();

        slowButton.textContent = "Click procesado ✓";
        setTimeout(() => {
          slowButton.textContent = "Hacer clic (interacción lenta)";
        }, 1000);

        logger.log("✅ Procesamiento completado");
        logger.log("⏳ Esperando análisis de Event Timing + LoAF...");
        logger.log("");
      });

      // Función pesada que causa el frame lento
      function heavyComputation() {
        const start = performance.now();
        let result = 0;

        // Cálculo pesado (~150ms) - garantizado para generar LoAF >50ms
        while (performance.now() - start < 150) {
          // Trabajo más intensivo para asegurar que genere LoAF
          for (let i = 0; i < 1000; i++) {
            result += Math.sqrt(Math.random()) * Math.sin(i);
          }
        }

        return result;
      }

      // Función para mostrar mensaje inicial
      function showInitialMessage() {
        logger.log("👋 Haz clic en el botón para ver la correlación Event Timing + LoAF");
        logger.log("📌 Verás exactamente qué script causó que la interacción fuera lenta");
        logger.log("");
      }

      // Limpiar
      clearBtn.addEventListener("click", () => {
        logger.clear();
        diagnosisDiv.innerHTML = "";
        showInitialMessage();
      });

      // Mensaje inicial
      showInitialMessage();
    